// 검사 vuex
const testStore = {
  namespaced: true,

  state: {
    testLibrary: {
      searchWord: '',
      testLibraryList: [],
      codePart: '',
      page: 0,
      scrollPosition: 0,
      partName: ''
    },
    testLibraryInfo: {
      testCode: ''
    },
    testIncongruity: {

    },

    testIncongruityDetail: {

    },

    testRequest: {

    },

    testRequestDetail: {

    },

    testRequestList: {

    },

    testResult: {

    },

    testIssueReminder: {

    },

    testIssueReminderDetail: {

    },

    testNameIsKoean: true
  },

  getters: {
    getTestLibrarySearchWord: state => state.testLibrary.searchWord,
    getTestLibraryInfoTestCode: state => state.testLibraryInfo.testCode,
    getTestIncongruity: state => state.testIncongruity,
    getTestIncongruityDetail: state => state.testIncongruityDetail,
    getTestRequest: state => state.testRequest,
    getTestRequestDetail: state => state.testRequestDetail,
    getTestRequestList: state => state.testRequestList,
    getTestLibrary: state => state.testLibrary,
    getTestResult: state => state.testResult,
    getTestNameIsKorean: state => state.testNameIsKoean,
    getTestIssueReminder: state => state.testIssueReminder,
    getTestIssueReminderDetail : state => state.testIssueReminderDetail
  },

  mutations: {
    mutationTestLibrarySearchWord: (state, payload) => {
      state.testLibrary.searchWord = payload
    },
    mutationTestLibraryInfoTestCode: (state, payload) => {
      state.testLibraryInfo.testCode = payload
    },
    mutationTestIncongrutity: (state, payload) => {
      state.testIncongruity = payload
    },

    mutationTestIncongrutityDetail: (state, payload) => {
      state.testIncongruityDetail = payload
    },

    mutationTestRequest: (state, payload) => {
      state.testRequest = payload
    },

    mutationTestRequestDetail: (state, payload) => {
      state.testRequestDetail = payload
    },

    mutationTestRequestList: (state, payload) => {
      state.testRequestList = payload
    },

    mutationTestLibrary: (state, payload) => {
      state.testLibrary = payload
    },

    mutationTestResult: (state, payload) => {
      state.testResult = payload
    },

    mutationTestIssueReminder: (state, payload) => {
      state.testIssueReminder = payload
    },

    mutationTestIssueReminderDetail: (state, payload) => {
      state.testIssueReminderDetail = payload
    },

    mutationTestNameIsKorean: (state, payload) => {
      state.testNameIsKoean = payload
    }

  }
}

export default testStore
